export const AgriculturalLoanContractListRouteName = 'agricultura-loan-contract-list'
export const AgriculturalLoanContractDetailRouteName = 'agricultura-loan-contract-detail'
export const AgriculturalLoanApplyFormRouteName = 'agricultura-loan-apply-form'
export const AgriculturalLoanAddressSelectRouteName = 'agricultura-loan-address-select'
export const AgriculturalLoanPackageSelectionRouteName = 'agricultura-loan-package-selection'
export const AgriculturalLoanDeviceListRouteName = 'agricultura-loan-device-list'
export const AgriculturalLoanPowerOfAttorneyRouteName = 'agricultura-loan-power-of-attorney'
export const AgriculturalLoanAgreementRouteName = 'agricultura-loan-agreement'
export const AgriculturalLoanAppListRouteName = 'agricultura-loan-app-list'
export const AgriculturalLoanAppFailRouteName = 'agricultura-loan-app-fail'
